import React from 'react';
import ADSBAircraftMap from './ADSBAircraftMap';
import HamburgerMenu from './HamburgerMenu';

const ControlTowerPage = ({ theme, toggleTheme }) => {
  return (
    <div
      className={`control-tower-page ${theme}`}
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: theme === 'dark' ? '#121212' : '#f8f9fa',
        color: theme === 'dark' ? '#e0e0e0' : '#212529',
      }}
    >
      <div
        style={{
          padding: '20px',
          borderBottom: `1px solid ${theme === 'dark' ? '#333' : '#e2e8f0'}`,
          backgroundColor: theme === 'dark' ? '#1a1a1a' : 'white',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            maxWidth: '1200px',
            margin: '0 auto',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <HamburgerMenu theme={theme} />
            <div>
              <h1
                style={{
                  margin: '0 0 10px 0',
                  fontSize: '28px',
                  fontWeight: 'bold',
                  color: theme === 'dark' ? '#e2e8f0' : '#2d3748',
                }}
              >
                🗼 Control Tower
              </h1>
              <p
                style={{
                  margin: '0',
                  color: theme === 'dark' ? '#a0aec0' : '#718096',
                  fontSize: '16px',
                }}
              >
                Live ADS-B aircraft tracking and airfield awareness
              </p>
            </div>
          </div>
          <button
            onClick={toggleTheme}
            style={{
              padding: '8px 16px',
              backgroundColor: theme === 'dark' ? '#4a5568' : '#e2e8f0',
              color: theme === 'dark' ? '#e2e8f0' : '#2d3748',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: '500',
            }}
          >
            {theme === 'dark' ? '☀️ Light' : '🌙 Dark'}
          </button>
        </div>
      </div>

      <div
        style={{
          flex: 1,
          position: 'relative',
          minHeight: '500px',
          overflow: 'hidden',
        }}
      >
        <ADSBAircraftMap theme={theme} />
      </div>

      <div
        style={{
          padding: '15px 20px',
          backgroundColor: theme === 'dark' ? '#1a1a1a' : 'white',
          borderTop: `1px solid ${theme === 'dark' ? '#333' : '#e2e8f0'}`,
          textAlign: 'center',
          color: theme === 'dark' ? '#a0aec0' : '#718096',
          fontSize: '14px',
        }}
      >
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          Control Tower — live ADS-B monitoring
        </div>
      </div>
    </div>
  );
};

export default ControlTowerPage;
